import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const bannersAccessControl: DomainAccessControlConfig = {
  permissions: Permission.BannersAdminPanel,
}
